<template>
<div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="width:100%;height:40px;margin-bottom:10px;">
        <div class="top_buttons">
            <el-button icon="el-icon-download" type="primary" @click="export_progress" style="width:240px;">导出进展</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-message" type="warning" @click="open_dialog" style="width:240px;">邮件跟催</el-button>
        </div>
        <!-- <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-setting" type="warning" @click="Reset_user_passwd">重置密码</el-button>
        </div> -->
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-download" type="primary" @click="export_results('health-survey_results.xlsx', 'exportJKSurveyResults')" style="width:240px;">导出组织健康度诊断结果</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-message" type="primary" @click="export_results('pain-spots_vote_results.xlsx', 'exportPainSpotsVoteResults')" style="width:240px;">导出管理痛点投票结果</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-setting" type="primary" @click="export_results('pain-spots_solution.xlsx', 'exportPainSpotsMgmtSolution')" style="width:240px;">导出管理痛点解决方案</el-button>
        </div>
    </div>
    <el-dialog class="reset_passwd_dialog" title="重置密码" :visible.sync="dialogFormVisible_resetpasswd" width="400px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
        <el-select v-model="reset_username" placeholder="请选择待重置密码的邮箱" style="width:260px;" clearable>
            <el-option
            v-for="item in reset_user_list"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
        <!-- <el-input v-model="reset_username" placeholder="请输入登录邮箱地址"></el-input> -->
        <div style="text-align:center;line-height:40px;">
            <el-button @click="cancle_reset">取 消</el-button>
            <el-button type="primary" @click="submit_reset" style="margin-top:30px;">确 定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="邮件跟催" 
        :visible.sync="dialogFormVisible" 
        width="450px" 
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="assessee_dialog">
            <el-form :model="form" class="dialog_form">
                <el-form-item label="调研类型" :label-width="formLabelWidth">
                    <el-select v-model="send_email_ques" placeholder="选择跟催的调研类型">
                        <el-option label="ALL" value="ALL"></el-option>
                        <el-option label="组织健康度调研" value="ques_a"></el-option>
                        <el-option label="管理痛点调研" value="ques_b"></el-option>
                        <el-option label="管理痛点献计献策" value="ques_c"></el-option>
                        <el-option label="管理痛点调研和献计献策" value="ques_d"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始日期" :label-width="formLabelWidth">
                    <el-date-picker 
                    v-model="form.effective_date" 
                    type="date" 
                    placeholder="请选择日期" 
                    format="yyyy 年 MM 月 dd 日" 
                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" :label-width="formLabelWidth">
                    <el-date-picker v-model="form.expiration_date" 
                    type="date" 
                    placeholder="请选择日期" 
                    format="yyyy 年 MM 月 dd 日" 
                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="send_emails">确 定</el-button>
            </div>
    </el-dialog> 
</div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        getdata.getList("checklogin")
              .then((resp) => {
                this.task_id = resp.data.task_id;
                // 当前页面仅限企业用户登录
                if(resp.data.usertype!='company'){
                    this.$router.push({
                    path: '/404',
                });
                }
              })
              .catch(() => {
                // if(localStorage.getItem("token") != null){
                //     this.$message({
                //         message: '会话超时，请重新登录！',
                //         type: 'warning',
                //     })
                // }
                this.$router.push({
                    path: '/JKlogin',
                });
              })
    },
    data() {
        return {
            task_id: null,
            template_file: {
                file_name: 'Assessment_progress_JK.xlsx'
            },
            dialogFormVisible_resetpasswd: false,
            reset_username: '',
            reset_user_list: [],
            dialogFormVisible: false,
            form: {
                effective_date: '',
                expiration_date: '',
            },
            send_email_ques: 'ALL',
            download_file: {
                file_name: ''
            },
        };
    },
    methods: {
        export_results(download_filename, api_name) {
            this.download_file.file_name = download_filename;
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP(api_name, JSON.stringify(this.download_file), params)
              .then(resp => {
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        open_dialog() {
            this.dialogFormVisible = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
            this.init_form();
        },
        send_emails() {
            this.dialogFormVisible = false;
            const loading = this.$loading({
                lock: true, // lock的修改符--默认是false
                text: '正在发送邮件，请稍后...', // 显示在加载图标下方的加载文案
                spinner: 'el-icon-loading', // 自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            })
            let params;
            params = {
                task_id: this.task_id,
                effective_date: this.form.effective_date,
                expiration_date: this.form.expiration_date,
                send_email_ques: this.form.send_email_ques,
            }
            getdata.getListP("sendJKEmails", params)
              .then((resp) => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: "success",
                    })
                    this.init_form();
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                    this.getProgressInfo();     // 有邮件发送失败时才更新结果
                }
                loading.close();
                })
              .catch(err => {
                console.log(err);
                loading.close();
              }) 
        },
        Reset_user_passwd() {
            let params = {
                'task_id': this.task_id,
            };
            getdata.getListP("getUserList", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.reset_user_list = resp.data.data;
                    this.dialogFormVisible_resetpasswd = true;
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }
            })
            .catch(() => {

            });
        },
        cancle_reset() {
            this.dialogFormVisible_resetpasswd = false;
        },
        submit_reset() {
            if(this.reset_username == ''){
                this.$message({
                    message: "请选择待重置密码的邮箱！",
                    type: "error",
                    duration: 6000,
                })
            }else{
                let params = {
                    'username': this.reset_username,
                    'task_id': this.task_id,
                };
                getdata.getListP("resetPasswdToDefault", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            this.dialogFormVisible_resetpasswd = false;
                        }else{
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                    })
                    .catch(() => {

                    });
            }
        },
        export_progress() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportJKProgress", JSON.stringify(this.template_file), params)
              .then(resp => {
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
    }
}
</script>

<style scoped>
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.top_buttons > .el-button {
    font-size: 16px;
}
.assessee_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.assessee_dialog /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
}
.dialog_form /deep/ .el-input {
    /* width: 223.67px; */
    width: 250px;
}
.dialog_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.dialog_form /deep/ .el-textarea__inner {
    font-family: Avenir,Helvetica,Arial,sans-serif;
}
.dialog_form /deep/ .el-alert__title {
    font-size: 14px;
}
::v-deep .el-dialog__footer {
    text-align: center;
}
</style>

